module.exports = __webpack_public_path__ + "img/PC_03.79bd3709.jpg";